import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import { Flex } from 'reflexbox'
import Select from 'react-select';

import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'
import Card from '../PartnerSiteSelection/Card'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import CardHeader from 'components/custom/Card/CardHeader'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Input from 'components/fulcrum/input/Input'
import InputWrapper from 'components/custom/InputWrapper'

import PartnerSiteTeam from '../PartnerSiteRole/PartnerSiteTeam'
import {
  setInactiveAddDialog,
} from 'containers/Admin/PartnerSite/PartnerSite/actions'
import {
  activeAddDialogSelector
} from 'containers/Admin/PartnerSite/PartnerSite/selectors'
import {
  resetSiteRolesChange,
} from 'containers/Admin/PartnerSite/PartnerSiteRole/actions'
import {
  partnerSiteListSelector,
  partnerSiteSelector,
  segmentSelector,
  lineSelector,
  partnerNameSelector,
  odmSelector,
  customerClassSelector,
  aeRegionSelector,
  aeRegionListSelector,
  segmentListSelector,
  lineListSelector,
  isPartnerSiteLoadingSelector
} from './selectors'
import {
  updatePartnerSite,
  updateSegment,
  updateLine,
  updatePartnerName,
  updateOdm,
  updateCustomerClass,
  updateAeRegion,
  postPartnerSite,
  fetchPartnerSitesHelper
} from './actions'
import PartnerSitesSagas from './sagas'
import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    partnerSiteSource: partnerSiteSelector(state),
    segmentSource: segmentSelector(state),
    lineSource: lineSelector(state),
    partnerNameSource: partnerNameSelector(state),
    odmSource: odmSelector(state),
    customerClassSource: customerClassSelector(state),
    aeRegionSource: aeRegionSelector(state),
    aeRegionListSource: aeRegionListSelector(state),
    segmentListSource: segmentListSelector(state),
    lineListSource: lineListSelector(state),
    partnerSiteList: partnerSiteListSelector(state),
    activeAddDialog: activeAddDialogSelector(state),
    isPartnerSiteLoading: isPartnerSiteLoadingSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setInactiveAddDialog: () => {
      dispatch(updatePartnerSite(''))
      dispatch(updateSegment(''))
      dispatch(updateLine(''))
      dispatch(updatePartnerName(''))
      dispatch(updateOdm(''))
      dispatch(updateCustomerClass(''))
      dispatch(updateAeRegion(''))
      dispatch(resetSiteRolesChange());
      dispatch(setInactiveAddDialog())
    },
    onPartnerSiteChange: (newPartnerSite) => {
      dispatch(updatePartnerSite( newPartnerSite ? newPartnerSite.value : '' ));
    },
    onSegmentChange: (newSegment) => {
      dispatch(updateSegment(newSegment))
      dispatch(fetchPartnerSitesHelper())
      dispatch(updatePartnerSite(''))
    },
    onLineChange: (newLine) => {
      dispatch(updateLine(newLine))
      dispatch(fetchPartnerSitesHelper())
      dispatch(updatePartnerSite(''))
    },
    onPartnerNameChange: (newPartnerName) => dispatch(updatePartnerName(newPartnerName)),
    onOdmChange: (newOdm) => dispatch(updateOdm(newOdm)),
    onCustomerClassChange: (newCustomerClass) => dispatch(updateCustomerClass(newCustomerClass)),
    onAeRegionChange: (newAeRegion) => dispatch(updateAeRegion(newAeRegion)),
    onSave: () => dispatch(postPartnerSite()),
  }
}

class PartnerSiteAddDialog extends Component {
  state = {
    teamCollapse: true,
    page: 1
  }

  resetState = () => {
    this.setState({
      teamCollapse: true,
      page: 1
    })
  }
  onCancel = () => {
    this.props.setInactiveAddDialog()
    this.resetState()
  }
  onSave = () => {
    this.props.onSave()
    this.props.setInactiveAddDialog()
    this.resetState()
  }
  onToggleCollapse = () => {
    this.setState((prev) => ({
      teamCollapse: !prev.teamCollapse
    }))
  }
  onNext = () => {
    this.setState({
      page: 2
    })
  }
  onBack = () => {
    this.setState({
      page: 1
    })
  }

  customerClassOptions = [
    {label: "OEM", value: 1},
    {label: "Channel", value: 2},
    {label: "CSP", value: 3},
    {label: "RoboTaxi", value: 4},
    {label: "ADAS", value: 5},
    {label: "IVI", value: 6},
    {label: "Embedded", value: 7},
  ]

  render() {
    const {
      activeAddDialog,
      setInactiveAddDialog,
      partnerSiteSource,
      segmentSource,
      lineSource,
      partnerNameSource,
      odmSource,
      customerClassSource,
      aeRegionSource,
      segmentListSource,
      lineListSource,
      partnerSiteList,
      onPartnerSiteChange,
      onSegmentChange,
      onLineChange,
      onPartnerNameChange,
      onOdmChange,
      onCustomerClassChange,
      onAeRegionChange,
      isPartnerSiteLoading,
      aeRegionListSource
    } = this.props

    const actions_page1 = [
      { label: 'Next', onClick: this.onNext, disabled: segmentSource == [] || lineSource == [] || partnerSiteSource == "" },
      { label: 'Cancel', onClick: this.onCancel },
    ]
  
    const actions_page2 = [
      { label: 'Back', onClick: this.onBack },
      { label: 'Save', onClick: this.onSave, disabled: partnerNameSource == "" || customerClassSource == "" || aeRegionSource == "" },
      { label: 'Cancel', onClick: this.onCancel },
    ]
  
    const {
      teamCollapse,
      page
    } = this.state

    return (
      <Dialog
        actions={page === 1 ? actions_page1 : actions_page2}
        active={activeAddDialog}
        title='Add Partner Site'
        onOverlayClick={setInactiveAddDialog}
        onEscKeyDown={setInactiveAddDialog}
      >
        <div className={styles.overflowWrapper}>
          {page === 1 && 
            <React.Fragment>
              <InputWrapper label={"Segment"} mandatory>
                <Dropdown
                  onChange={onSegmentChange}
                  value={segmentSource}
                  source={segmentListSource}
                  hint={"Choose Segment"}
                />
              </InputWrapper>
              <InputWrapper
                label={"Line"}
                className={styles.line}
                mandatory
              >
                <Dropdown
                  onChange={onLineChange}
                  value={lineSource}
                  source={lineListSource}
                  hint={"Choose Line"}
                />
              </InputWrapper>
              <InputWrapper 
                label={"Partner Site"} 
                className={styles.partnerSite}
                mandatory
              >
                <Select
                  placeholder={"Select Partner Site"}
                  isLoading={isPartnerSiteLoading}
                  value={partnerSiteSource}
                  onChange={onPartnerSiteChange}
                  options={partnerSiteList}
                  disabled={(segmentSource == "" || lineSource == "") || isPartnerSiteLoading}
                />
              </InputWrapper>
            </React.Fragment>}
          {page === 2 && 
            <React.Fragment>
              <InputWrapper label={"Partner Name"} mandatory>
                <Input
                  placeholder={"Type Partner Name"}
                  value={partnerNameSource}
                  onChange={onPartnerNameChange}
                />
              </InputWrapper>
              <InputWrapper
                label={"ODM Name"}
              >
                <Input
                  placeholder={"Type ODM Name"}
                  value={odmSource}
                  onChange={onOdmChange}
                />
              </InputWrapper>
              <InputWrapper
                label={"Customer Class"}
                className={styles.customerClass}
                mandatory
              >
                <Dropdown
                  onChange={onCustomerClassChange}
                  value={customerClassSource}
                  source={this.customerClassOptions}
                  hint={"Choose Customer Class"}
                />
              </InputWrapper>
              <InputWrapper
                label={"AE Region"}
                className={styles.aeRegion}
                mandatory
              >
                <Dropdown
                  onChange={onAeRegionChange}
                  value={aeRegionSource}
                  source={aeRegionListSource}
                  hint={"Choose AE Region"}
                />
              </InputWrapper>
              <Card>
                  <CardHeader title={"Team"}>
                    <Flex justify='flex-end'>
                      <CollapseIconButton
                        toggleCollapse={this.onToggleCollapse}
                        collapse={teamCollapse}
                      />
                    </Flex>
                  </CardHeader>
                <Collapse collapse={teamCollapse}> 
                  <PartnerSiteTeam />
                </Collapse>
              </Card>
            </React.Fragment>}
        </div>
      </Dialog>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const withSagas = injectSagas({ PartnerSitesSagas })

export default compose(
  withConnect,
  withStyle,
  withSagas
)(PartnerSiteAddDialog)
